const searchList = [];

const reducer = (state = searchList, action) => {
  switch (action.type) {
    case 'search_field':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
